import { ThemeComponent, ThemeGuard, ThemeResolver } from '@awp/theme';
import { ContentPageComponent, DocumentComponent } from './components';
import { ThemeContextResolver } from '@awp/theme';
import { EmptyLayoutComponent, BasicLayoutComponent, SiteLayoutComponent } from '@awp/layout';
import { RootThemeResolver, CheckErrorPageExistsGuard, ContentErrorPageResolver, ThemeNoMenuGuard, CheckMenuExistsGuard, MenuContentResolver } from '@awp/content-router';
import { MenuResolver } from './resolvers/menu.resolver';
var ɵ0 = function () { return import("./../../../../libs/nac/quote/ui/src/lib/quote-ui.module.ngfactory").then(function (m) { return m.QuoteUiModuleNgFactory; }); };
export var ROUTES = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'page/not-found'
    },
    {
        path: 'page',
        component: BasicLayoutComponent,
        resolve: {
            theme: RootThemeResolver
        },
        children: [
            {
                path: ':pageId',
                component: ContentPageComponent,
                canActivate: [CheckErrorPageExistsGuard],
                resolve: {
                    content: ContentErrorPageResolver,
                }
            }
        ]
    },
    {
        path: ':themeId',
        component: ThemeComponent,
        canActivate: [ThemeGuard],
        canActivateChild: [ThemeNoMenuGuard],
        runGuardsAndResolvers: 'always',
        children: [
            {
                path: 'quote',
                component: EmptyLayoutComponent,
                loadChildren: ɵ0
            },
            {
                path: 'page',
                component: BasicLayoutComponent,
                children: [
                    {
                        path: ':pageId',
                        component: ContentPageComponent,
                        canActivate: [CheckErrorPageExistsGuard],
                        resolve: {
                            content: ContentErrorPageResolver,
                            properties: ThemeContextResolver,
                            theme: ThemeResolver
                        }
                    }
                ]
            },
            {
                path: 'document/:documentType',
                component: DocumentComponent,
                resolve: {
                    theme: ThemeResolver
                }
            },
            {
                path: '',
                component: SiteLayoutComponent,
                children: [
                    {
                        path: ':menuId',
                        component: ContentPageComponent,
                        canActivate: [CheckMenuExistsGuard],
                        resolve: {
                            content: MenuContentResolver,
                            properties: ThemeContextResolver,
                            theme: ThemeResolver,
                            menu: MenuResolver
                        }
                    }
                ]
            },
            {
                path: '**',
                redirectTo: 'page/not-found'
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'page/not-found'
    }
];
export { ɵ0 };
